<!--
 * @Author: your name
 * @Date: 2022-02-24 14:29:00
 * @LastEditTime: 2022-02-24 15:30:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sga-fd-sgaH5NEW\xyusermodule\src\views\myCard\index.vue
--> 
<template>
  <div class="card-list-wrapper">
    <div class="bg">
      <p>襄阳市政务综合服务大厅</p>
    </div>
    <h3>
      热门服务
    </h3>
    <div class="item-list">
      <ul>
        <li @click="toClick(item.url)" v-for="(item,index) of list" :key="index">
          <img :src="item.img" alt="">
          <span>{{item.title}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
   data() {
     return {
       list:[
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"政府文件",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"政策解读",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"灾情灾害数据",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"水利建设投资合同签订信息",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"水利工程信息",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"企业公示-许可信息",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"企业公示-行政处罚",
        //    url:""
        //  },
        //  {
        //    img:require("@/assets/img/card/chubanwu.jpg"),
        //    title:"企业公示-项目工程信息",
        //    url:""
        //  },
         {
           img:require("@/assets/img/card/chubanwu.jpg"),
           title:"出版物经营许可证",
           url:"/cardList"
         }
       ]
     }
   },
   methods: {
     toClick(url) {
       if(url) {
         window.location.href = "https://ixy.xydatacenter.cn/sga/sgah5/usermodule/#/cardList"
        //  this.$router.push(url)
       }
     }
   }
}
</script>

<style lang="less" scoped>
  .card-list-wrapper {
    height: 100vh;
    background: #fff;
    .bg {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 120px;
      background: url("~@/assets/img/card/header_bg.jpg");
      background-size: 100% 100%;
      p {
        color: #fff;
        font-weight: 700;
        font-size: 18px;
      }
    }
    h3 {
      padding: 28px 14px 20px;
      color:#333;
      font-size: 16px;
      font-weight: 700;
    }
    .item-list {
      padding:0 14px;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          margin-bottom: 10px;
          display: flex;
          width: 50%;
          align-items: center;
          img {
            margin-right: 10px;
            width: 28px;
            height: 28px;
          }
          span {
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
</style>>

